var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyProfit = function SvgMoneyProfit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#581789",
    strokeWidth: 2,
    d: "M26.702 38.547c0 .687.601 1.593 2.225 2.386 1.557.76 3.778 1.259 6.287 1.259s4.729-.499 6.286-1.26c1.624-.792 2.225-1.698 2.225-2.385 0-.688-.601-1.593-2.225-2.386-1.557-.76-3.779-1.26-6.286-1.26-2.509 0-4.73.5-6.287 1.26-1.624.793-2.225 1.698-2.225 2.386Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#581789",
    strokeWidth: 2,
    d: "M26.702 33.68c0 .688.601 1.593 2.225 2.386 1.557.761 3.778 1.26 6.287 1.26s4.729-.499 6.286-1.26c1.624-.793 2.225-1.698 2.225-2.385 0-.688-.601-1.593-2.225-2.386-1.557-.76-3.779-1.26-6.286-1.26-2.509 0-4.73.5-6.287 1.26-1.624.793-2.225 1.698-2.225 2.386Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#581789",
    strokeWidth: 2,
    d: "M26.702 28.814c0 .688.601 1.593 2.225 2.386 1.557.76 3.778 1.26 6.287 1.26s4.729-.5 6.286-1.26c1.624-.793 2.225-1.698 2.225-2.386 0-.687-.601-1.593-2.225-2.386-1.557-.76-3.779-1.259-6.286-1.259-2.509 0-4.73.499-6.287 1.26-1.624.793-2.225 1.698-2.225 2.385Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#581789",
    strokeWidth: 2,
    d: "M26.702 23.949c0 .687.601 1.593 2.225 2.386 1.557.76 3.778 1.259 6.287 1.259s4.729-.499 6.286-1.26c1.624-.792 2.225-1.698 2.225-2.385 0-.688-.601-1.593-2.225-2.386-1.557-.76-3.779-1.26-6.286-1.26-2.509 0-4.73.5-6.287 1.26-1.624.793-2.225 1.698-2.225 2.386ZM5.911 38.547c0 .687.601 1.593 2.225 2.386 1.557.76 3.778 1.259 6.287 1.259 2.507 0 4.729-.499 6.286-1.26 1.624-.792 2.225-1.698 2.225-2.385 0-.688-.601-1.593-2.225-2.386-1.557-.76-3.779-1.26-6.286-1.26-2.509 0-4.73.5-6.287 1.26-1.624.793-2.225 1.698-2.225 2.386Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#581789",
    strokeWidth: 2,
    d: "M5.911 33.68c0 .688.601 1.593 2.225 2.386 1.557.761 3.778 1.26 6.287 1.26 2.507 0 4.729-.499 6.286-1.26 1.624-.793 2.225-1.698 2.225-2.385 0-.688-.601-1.593-2.225-2.386-1.557-.76-3.779-1.26-6.286-1.26-2.509 0-4.73.5-6.287 1.26-1.624.793-2.225 1.698-2.225 2.386Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#581789",
    strokeWidth: 2,
    d: "M23.225 19.003V6.335m0 0H10.556m12.67 0L6.333 23.225"
  })));
};
export default SvgMoneyProfit;